<template>
    <div v-if="isShow" :style="domStyle" class="userTable">
            <Table border :columns="columns12" :data="data">
                <template slot-scope="{ row }" slot="name">
                    <strong>{{ row.name }}</strong>
                </template>
                <template slot-scope="{ row, index }" slot="action">
                    <Button type="error" size="small" @click="remove(index)">强制退出</Button>
                </template>
            </Table>
        <div v-if="isEnable" :style="enableStyle">
            
        </div>
    </div>
</template>
<style>
    .userTable .ivu-table-overflowX{
        overflow-x:"revert";
    }
</style>
<script>
/**
 * 用户管理
 */
import Vue from 'vue';
import axios from 'axios'
export default {
    name : "fvUserTable",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : 0 + "px",
            top : 0 + "px",
            width : 0 + "px",
            height : 0 + "px",
            overflow: "auto",
            backgroundColor:"#fff"
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
    },
    mounted(){
        //获取所有的用户列表
       this.$store.state.system.$.dbCom.sendMessage({
            "head":"getUsers",
        },(err,result)=>{
            for(var i=0;i<result.length;i++){
                result[i]["number"] = result[i].socketIds.length;
            }
            this.data = result;
        }); 
    },
    data(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
           
            // 版本号
            version: "10.0.3.1",
            columns12: [
                    {
                        title: '用户名',
                        key: 'userName'
                    },
                    {
                        title: 'IP',
                        key: 'ip'
                    },
                    {
                        title: '数量',
                        key: 'number'
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 150,
                        align: 'center'
                    }
                ],
            data: []
        }
    },
    methods : {
        remove (index,row) {
            //监听socket监听断开 强制退出
             this.$store.state.system.$.dbCom.sendMessage({
                "head":"logOutUser",
                "message": {
                    "socketIds": this.data[index].socketIds
                }
            },(err,result)=>{
                this.data.splice(index, 1);
            });
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            if(this.fontSize){
                this.domStyle.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            };
            if(scaleObj.titleHeight != 0){
                var titleHeight = 0;
            }else{
                var titleHeight = this.y * this.frameScaleY;
            }
            this.domStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.domStyle.top = parseInt(((this.y )* (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.domStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
            this.domStyle.overflow = "auto";
            
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
            if(this.isEnable){
                this.setPause();
            }
        },
        /*
            参数：src ：外部属性（对象）
            作用：混淆属性
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：无
            作用：监听组件内部属性
        */
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/primitives/fvUserTable/fvUserTable.vue